import React, { useState, useEffect } from "react";
import ApiService from "../Service/ApiService";
import { useNavigate } from "react-router-dom";
import "./MobileUpMenu.css";
import Drawer from "../Drawer/Drawer";
import projectData from "../../data/projects.json";
import buildingsData from "../../data/buildings.json";
import newsData from "../../data/news.json";
import jobData from "../../data/staff.json";

const MobileUpMenu = ({ isOpen, onClose, isAlbanian, toggleLanguage }) => {
  const navigate = useNavigate();
  const [expandCompany, setExpandCompany] = useState(false);
  const [expandProject, setExpandProject] = useState(false);
  const [expandSales, setExpandSales] = useState(false);
  const [expandNews, setExpandNews] = useState(false);
  const [expandJobs, setExpandJobs] = useState(false);
  const [jobs, setJobs] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [projects, setProjects] = useState([]);
  const [catalogs, setCatalogs] = useState([]);
  const [news, setNews] = useState([]);

  useEffect(() => {
    if (projectData && projectData.length > 0) {
      const shuffledProjects = [...projectData].sort(() => 0.5 - Math.random());
      setProjects(shuffledProjects);
    }

    if (buildingsData && buildingsData.length > 0) {
      const shuffledBuildings = [...buildingsData].sort(
        () => 0.5 - Math.random()
      );
      setCatalogs(shuffledBuildings);
    }

    if (newsData && newsData.length > 0) {
      const shuffledNews = [...newsData].sort(() => 0.5 - Math.random());
      setNews(shuffledNews);
    }

    if (jobData && jobData.length > 0) {
      const shuffledJobs = [...jobData].sort(() => 0.5 - Math.random());
      setJobs(shuffledJobs);
    }
  }, []);

  const handleCompanyClick = (e) => {
    e.stopPropagation();
    setExpandCompany(!expandCompany);
  };

  const handleProjectClick = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setExpandProject(!expandProject);
  };

  const handleSalesClick = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setExpandSales(!expandSales);
  };

  const handleNewsClick = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setExpandNews(!expandNews);
  };

  const handleJobsClick = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setExpandJobs(!expandJobs);
  };

  const handleMenuItemClick = () => {
    onClose();
  };

  const toggleDrawer = () => {
    setIsDrawerOpen((prev) => !prev);
  };

  return (
    <>
      <div className={`mobile-upmenu-container ${isOpen ? "open" : ""}`}>
        <div className="mobile-upmenu-overlay" onClick={onClose}></div>
        <div
          className="mobile-upmenu-content"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="mobile-upmenu-header">
            <div className="mobile-logo-div">
              <img
                src="/vilallogonavred.png"
                alt="logo"
                className="mobile-logo"
                onClick={() => navigate("/")}
              />
            </div>
            <div className="mobile-close-div">
              <button className="mobile-upmenu-close" onClick={onClose}>
                &times;
              </button>
            </div>
          </div>
          <ul className="mobile-upmenu-items">
            <li className="mobile-upmenu-item" onClick={handleCompanyClick}>
              {isAlbanian ? "Kompania jonë" : "Our Company"}{" "}
              <span className="mobile-triangle">
                {expandCompany ? "▲" : "▼"}
              </span>
            </li>
            {expandCompany && (
              <ul className="mobile-submenu">
                <li
                  onClick={() => {
                    navigate("/", { state: { targetId: "aboutUs" } });
                    handleMenuItemClick();
                  }}
                >
                  {isAlbanian ? "Rreth Nesh" : "About Us"}
                </li>
                <li
                  onClick={() => {
                    navigate("/", { state: { targetId: "ourCulture" } });
                    handleMenuItemClick();
                  }}
                >
                  {isAlbanian ? "Vizioni Ynë" : "Our Vision"}
                </li>
                <li
                  onClick={() => {
                    navigate("/", { state: { targetId: "ourHistory" } });
                    handleMenuItemClick();
                  }}
                >
                  {isAlbanian ? "Historia Jonë" : "Our History"}
                </li>
                <li
                  onClick={() => {
                    navigate("/", { state: { targetId: "ourTeam" } });
                    handleMenuItemClick();
                  }}
                >
                  {isAlbanian ? "Ekipi Ynë" : "Our Team"}
                </li>
              </ul>
            )}
            <li
              className="mobile-upmenu-item"
              onClick={(e) => {
                handleProjectClick(e);
              }}
            >
              {isAlbanian ? "Projektet tona" : "Our Projects"}{" "}
              <span className="mobile-triangle">
                {expandProject ? "▲" : "▼"}
              </span>
            </li>
            {expandProject && (
              <ul className="mobile-submenu">
                <li
                  className="mobile-upmenu-item"
                  onClick={() => {
                    navigate("/ourcompany", {
                      state: { targetId: "projects" },
                    });
                    handleMenuItemClick();
                  }}
                >
                  {isAlbanian ? "Të gjitha projektet tona" : "All Our Projects"}
                </li>
                {projects.slice(0, 5).map((project) => (
                  <li
                    key={project.project_id}
                    onClick={() => {
                      navigate(`/vilalproject/${project.project_id}`);
                      handleMenuItemClick();
                    }}
                  >
                    {project.project_title}
                  </li>
                ))}
              </ul>
            )}
            <li
              className="mobile-upmenu-item"
              onClick={(e) => {
                handleSalesClick(e);
              }}
            >
              {isAlbanian ? "Katalogu i shitjeve" : "Sales catalog"}{" "}
              <span className="mobile-triangle">{expandSales ? "▲" : "▼"}</span>
            </li>
            {expandSales && (
              <ul className="mobile-submenu">
                <li
                  className="mobile-upmenu-item"
                  onClick={() => {
                    navigate("/salescatalog", {
                      state: { targetId: "firstSalesRow" },
                    });
                    handleMenuItemClick();
                  }}
                >
                  {isAlbanian
                    ? "Të gjitha kataloget tona"
                    : "All Our Sales Catalogs"}
                </li>
                {catalogs.slice(0, 5).map((catalog) => (
                  <li
                    key={catalog.building_id}
                    onClick={() => {
                      navigate(`/secondstep/${catalog.building_id}`);
                      handleMenuItemClick();
                    }}
                  >
                    {isAlbanian
                      ? catalog.titulli_nderteses
                      : catalog.building_title}
                  </li>
                ))}
              </ul>
            )}
            <li
              className="mobile-upmenu-item"
              onClick={(e) => {
                handleNewsClick(e);
              }}
            >
              {isAlbanian ? "Lajme dhe evente" : "News & Insight"}{" "}
              <span className="mobile-triangle">{expandNews ? "▲" : "▼"}</span>
            </li>
            {expandNews && (
              <ul className="mobile-submenu">
                <li
                  className="mobile-upmenu-item"
                  onClick={() => {
                    navigate("/news", { state: { targetId: "newsSection" } });
                    handleMenuItemClick();
                  }}
                >
                  {isAlbanian ? "Të gjitha lajmet tona" : "All Our News"}
                </li>
                {news.slice(0, 5).map((news) => (
                  <li
                    key={news.news_id}
                    onClick={() => {
                      navigate(`/newsdetails/${news.news_id}`);
                      handleMenuItemClick();
                    }}
                  >
                    {isAlbanian ? news.titull_lajmesh : news.news_title}
                  </li>
                ))}
              </ul>
            )}
            <li
              className="mobile-upmenu-item"
              onClick={(e) => {
                handleJobsClick(e);
              }}
            >
              {isAlbanian ? "Karriera" : "Careers"}{" "}
              <span className="mobile-triangle">{expandJobs ? "▲" : "▼"}</span>
            </li>
            {expandJobs && (
              <ul className="mobile-submenu">
                <li
                  className="mobile-upmenu-item"
                  onClick={() => {
                    navigate("/staff", { state: { targetId: "meet" } });
                    handleMenuItemClick();
                  }}
                >
                  {isAlbanian ? "Stafi ynë" : "OurStaff"}
                </li>
                {jobs.slice(0, 5).map((job) => (
                  <li
                    key={job.staffId}
                    onClick={() => {
                      navigate(`/jobdetails/${job.staff_id}`);
                      handleMenuItemClick();
                    }}
                  >
                    {isAlbanian ? job.titulli_staf : job.staff_tittle}
                  </li>
                ))}
              </ul>
            )}
          </ul>
          <div className="mobile-upmenu-contact">
            <div className="mobile-upmenu-contact-red">
              <li
                className="mobile-upmenu-contact-contact"
                onClick={toggleDrawer}
              >
                {isAlbanian ? "Kontakt" : "Contact"}
              </li>
              <li onClick={toggleLanguage}>
                {isAlbanian ? "English" : "Shqip"}
                <img
                  src={isAlbanian ? "/uk.png" : "/al.png"}
                  className="mobile-flag-nav"
                  alt="flag"
                />
              </li>
            </div>
            <div className="mobile-upmenu-contact-social">
              <li
                onClick={() =>
                  (window.location.href =
                    "https://www.facebook.com/share/19coQCi7jY/?mibextid=LQQJ4d")
                }
              >
                Facebook
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://www.instagram.com/vilalgroup?igsh=cWR2Nm1qdWlicnly")
                }
              >
                Instagram
              </li>
              <li
                onClick={() =>
                  (window.location.href =
                    "https://www.linkedin.com/company/vilalgroup")
                }
              >
                LinkedIn
              </li>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        isOpen={isDrawerOpen}
        onClose={toggleDrawer}
        isAlbanian={isAlbanian}
      />
    </>
  );
};

export default MobileUpMenu;
